export const TRANSLATIONS_PT_SETTINGS_GOOGLE = {
  "settings.google.connection_status_title": "Estado da conexão",
  "settings.google.loading_status": "Carregando estado...",
  "settings.google.connected": "Conectado",
  "settings.google.connect_button": "Conectar com o Google",
  "settings.google.no_accounts": "Nenhuma conta conectada.",
  "settings.google.gmail_messages_title": "Mensagens do Gmail",
  "settings.google.no_messages": "Não há mensagens para mostrar.",
  "settings.google.drive_files_title": "Arquivos do Drive",
  "settings.google.root": "(Raiz)",
  "settings.google.no_files": "Não há arquivos para mostrar.",
  "settings.google.diagnostics_title": "Diagnóstico e testes",
  "settings.google.audit_title": "Auditoria e segurança",
  "settings.google.manage_access_link": "Gerenciar acesso na minha Conta do Google",
  "settings.google.privacy_policy": "Política de privacidade",
  "settings.google.terms_of_service": "Termos de serviço",
  "settings.google.multi_account_title": "Gerenciamento multi‑conta",
  "settings.google.reauthorize": "Reautorizar",
  "settings.google.revoke": "Revogar",
  "settings.google.make_default": "Definir como padrão",
  "settings.google.oauth_processing": "Processando autenticação do Google...",
  "settings.google.table.subject": "Assunto",
  "settings.google.table.from": "De",
  "settings.google.table.received_at": "Recebido",
  "settings.google.table.body_preview": "Pré-visualização",
  "settings.google.table.has_attachments": "Anexos",
  "settings.google.table.name": "Nome",
  "settings.google.table.type": "Tipo",
  "settings.google.table.size": "Tamanho",
  "settings.google.table.modified": "Modificado",
  "settings.google.table.created_by": "Criado por",
  "settings.google.table.status": "Estado",
  "settings.google.table.time": "Hora",
  "settings.google.table.message": "Mensagem",
  "settings.google.table.account": "Conta",
  "settings.google.table.scopes": "Escopos",
  "settings.google.table.default": "Padrão",
  "settings.google.table.actions": "Ações",
  "settings.google.table.sync_period": "Sincronizar desde",
  "settings.google.save_sync_start_date": "Salvar data",
  "settings.google.sync_process_title": "Sincronização da conta",
  "settings.google.sync.mail_sync_status": "Estado sincronização correio",
  "settings.google.sync.drive_sync_status": "Estado sincronização drive",
  "settings.google.sync.last_read_email_date": "Data do último e-mail sincronizado",
  "settings.google.sync.last_sync_date": "Última sincronização",
  "settings.google.sync.emails_processed": "E-mails processados",
  "settings.google.sync.period": "Período de sincronização",
  "settings.google.sync.period_updated_prefix": "Data de inicio de sincronizacao atualizada para",
  "settings.google.sync.resync_requested": "Ressincronizacao solicitada.",
  "settings.google.sync.set_period": "Definir período",
  "settings.google.sync.all": "Todos",
  "settings.google.sync.not_set": "Não definido",
};
